import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class ProfessionForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  order: number = 0
  defaultHourlyRate: number = 0
  allowedActivityTypeIds: number[] = []

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire'))
  }

  constructor(data?: Partial<ProfessionForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.order = data.order ?? 0
      this.defaultHourlyRate = data.defaultHourlyRate ?? 0
      this.allowedActivityTypeIds = data.allowedActivityTypeIds ?? []
    }
  }
}
